import { createContext, useContext, useState, ReactNode, useMemo } from 'react';

export enum MachineType {
  SmartBagger,
  EasyPack,
}

export enum SyncStatus {
  None,
  Unknown,
  Pending,
  InProgress,
  Cancelled,
  Finished,
  Failed,
}

type MachineGroupContextType = {
  machineType: string;
  customerId: string;
  syncStatus: SyncStatus;
  setMachineType: React.Dispatch<React.SetStateAction<string>>;
  setSyncStatus: React.Dispatch<React.SetStateAction<SyncStatus>>;
  setCustomerId: React.Dispatch<React.SetStateAction<string>>;
};

const MachineContext = createContext<MachineGroupContextType | undefined>(
  undefined,
);

export function MachineGroupProvider({ children }: { children: ReactNode }) {
  const [machineType, setMachineType] = useState<string>(
    MachineType[MachineType.SmartBagger],
  );

  const [syncStatus, setSyncStatus] = useState<SyncStatus>(SyncStatus.None);
  const [customerId, setCustomerId] = useState<string>('');

  const contextValue = useMemo(
    () => ({
      machineType,
      syncStatus,
      customerId,
      setMachineType,
      setSyncStatus,
      setCustomerId,
    }),
    [machineType, syncStatus, customerId],
  );

  return (
    <MachineContext.Provider value={contextValue}>
      {children}
    </MachineContext.Provider>
  );
}

export const useMachineGroupContext = () => {
  const context = useContext(MachineContext);
  if (!context)
    throw new Error(
      'useMachineGroupContext must be used within MachineGroupProvider',
    );
  return context;
};
